// File: resources/js/Pages/ScriptSnout/ScriptSnout.jsx
import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';

import SunburstChart from './SunburstChart';
import InfoPanel from './InfoPanel/InfoPanel';
import Controls from './Controls';
import './grades.css';

export default function ScriptSnout ({ movie }) {
  const [includeScenes, setIncludeScenes] = useState(true);
  const [selectedNode, setSelectedNode]   = useState(null);
  const [metric, setMetric]               = useState('overall');

  const toggleScenes   = () => setIncludeScenes(prev => !prev);
  const handleSelect = useCallback((node, currentMetric) => {
    setSelectedNode({ 
      ...node, 
      selectedMetric: currentMetric !== 'overall' ? currentMetric : null 
    });
  }, []);

  return ( 
    <>
      <div className="container-fluid px-3 h-100">
        <div className="row g-0 h-100">
          {/* Left column - Sunburst (fixed) */}
          <div className="col-md-6 h-100 d-flex flex-column">
            <div className="flex-shrink-0">
              <Controls includeScenes={includeScenes} onToggle={toggleScenes}
                        metric={metric} onMetricChange={setMetric}/>
            </div>
            <div className="flex-grow-1 position-relative">
              {/* Pass the stable callback directly. An inline arrow here makes a
                  new function every render, which is a dependency of the chart's
                  effect — it would re-plot the whole sunburst on every selection
                  and break double-click-to-zoom. The chart calls
                  onSelect(node, metric), and handleSelect already takes both. */}
              <SunburstChart movie={movie}
                           includeScenes={includeScenes}
                           metric={metric}
                           onSelect={handleSelect}/>
            </div>
          </div>
          
          {/* Right column - Info Panel (scrollable) */}
          <div className="col-md-6 d-none d-md-block h-100">
            <div className="h-100 overflow-auto">
              <InfoPanel node={selectedNode}/>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

ScriptSnout.propTypes = {
  movie: PropTypes.object.isRequired,
};